import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const WelcomeBar = () => {
  const { user } = useAuth();

  // Funzione per generare il messaggio di benvenuto
  const getWelcomeMessage = () => {
    if (!user || !user.name) return "Benvenuto!";
    
    const fullName = user.name.trim();
    
    // Determina se il nome è femminile (finisce con 'a')
    const isFemale = fullName.toLowerCase().endsWith('a') && 
                     !fullName.toLowerCase().endsWith('ia') &&
                     !fullName.toLowerCase().endsWith('ua');
    
    return isFemale ? `Benvenuta, ${fullName}!` : `Benvenuto, ${fullName}!`;
  };

  return (
    <div className="fixed top-16 left-0 right-0 z-40 bg-blue-50 dark:bg-blue-900/20 border-b border-blue-200 dark:border-blue-800 py-1.5 px-6">
      <div className="max-w-7xl mx-auto">
        <p className="text-blue-800 dark:text-blue-200 font-semibold text-base text-center">
          {getWelcomeMessage()}
        </p>
      </div>
    </div>
  );
};

export default WelcomeBar;
